import * as React from "react";
import Axios from "axios";
import Swal from "sweetalert2";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import moment from "moment";

export const handleLogout = () => {
  Swal.fire({
    icon: "error",
    title: "Logout ?",
    showCancelButton: true,
    confirmButtonText: "Yes",
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      RemoveSession();
      window.location.href = "/cmsAdmin";
    }
  });
};

export const seesionCheck = async () => {
  try {
    let result = await Axios.get(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/check_access",
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result.data;
  } catch (error) {
    RemoveSession();
    window.location.href = "/cmsAdmin";
    console.log(`bigc-online-catalogs: ${error}`);
  }
};

export const AddSession = (user) => {
  sessionStorage.setItem("accessToken", user.accessToken);
  sessionStorage.setItem("userId", user.id);
  sessionStorage.setItem("name", user.name);
  sessionStorage.setItem("role", user.role);
  sessionStorage.setItem("email", user.email);
  sessionStorage.setItem(
    "accessTokenTime",
    moment().add(process.env.REACT_APP_SESSION_TIMEOUT_HOURS, "hours").valueOf()
  );
};

export const RemoveSession = () => {
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("userId");
  sessionStorage.removeItem("name");
  sessionStorage.removeItem("role");
  sessionStorage.removeItem("email");
  sessionStorage.removeItem("accessTokenTime");
};

export function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.bigc.co.th">
        BigC-TH
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export function textStatus(vals) {
  let txt = "";
  switch (vals) {
    case 1:
      txt = "Active";
      break;
    default:
      txt = "Inactive";
      break;
  }
  return txt;
}
